import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';

@Injectable()
export class PermissionHelper {
  userPages: Array<string> = [];
  userMethods: Array<string> = [];

  constructor(private userService: UserService) {
    this.userPages = this.userService.getMe()?.permittedPages;
    this.userMethods = this.userService.getMe()?.permittedMethods;
  }

  isEnabledMethod(method: string) {
    return this.userMethods.includes(method);
  }
}
